// extracted by mini-css-extract-plugin
module.exports = {"action":"style_action__3XrZ7","print":"style_print__1LMYH"};